<i360-modal-content
    [showConfirm]="false">
    <ng-container modal-title>{{ 'utils.modals.fileViewer.title' | translate: { path: data.path } }}</ng-container>
    <ng-container modal-body>
        <label *ngIf="data.limit < data.size" for="file-viewer">
            {{ 'utils.modals.fileViewer.shownFirst' | translate: { size: data.limit / 1024 } }}
        </label>
        <textarea id="file-viewer" readonly>{{ data.chunk }}</textarea>
    </ng-container>
</i360-modal-content>